import { globalStyleSheet } from "@/assets/css/global";
import playIcon from '@/assets/images/play.svg';
import pauseIcon from '@/assets/images/pause.svg';
const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(`
    :host {
      display: flex;
      width: 36px;
      min-width: 36px;
      height: 36px;
      border-radius: 6px;
      overflow: hidden;
    }
    
    #play, #pause {
        color: white;
        width: 20px;
        height: 20px;
    }
    
    #pause {
        display: none;
    }
    
    .playing #pause  {
        display: revert-layer;
    }
    
    .playing #play {
        display: none
    }
    
    button {
        padding: 4px;
        outline: none;
        background-color: var(--color-player-button);
        border-radius: 6px;
        border-color: transparent;
        color: white;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`);
export class RPlayButton extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [globalStyleSheet, styleSheet];
    }
    connectedCallback() {
        this.#abortController = new AbortController();
        this.#initDOM();
    }
    disconnectedCallback() {
        this.#abortController.abort();
    }
    /** @param {boolean} isPlaying */
    set isPlaying(isPlaying) {
        this.#buttonEl.classList.toggle('playing', isPlaying);
    }
    /** @type {AbortController | undefined} */
    #abortController;
    get #buttonEl() {
        return this.shadowRoot.querySelector('button');
    }
    #initDOM() {
        this.shadowRoot.innerHTML = `
            <button>
                <r-icon url="${playIcon}" id="play"></r-icon>
                <r-icon url="${pauseIcon}" id="pause"></r-icon>
            </button>
        `;
        this.#buttonEl.addEventListener('click', () => {
            this.#buttonEl.classList.toggle('playing');
        }, { signal: this.#abortController.signal });
    }
}
customElements.define('r-play-button', RPlayButton);
